import { createRouter, createWebHistory } from 'vue-router'
import type { NavigationGuard, RouteRecordRaw } from 'vue-router'

import GlobalDataService from '../services/GlobalDataService'
import PermissionsService from '../services/PermissionsService'
// @ts-ignore: suppress "Could not find a declaration file for module"
import AuthenticatedView from '../components/layouts/AuthenticatedView.vue'

import PassthroughView from '../components/views/PassthroughView.vue'
import NotFound from '../components/views/NotFound.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import LoginView from '../components/public/LoginView.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import OrganizationIndex from '../components/views/organizations/OrganizationIndex.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import ConfirmAccountView from '../components/public/ConfirmAccountView.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import ForgotPasswordView from '../components/public/ForgotPasswordView.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import ConfirmForgotPasswordView from '../components/public/ConfirmForgotPasswordView.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import ProductIndex from '../components/views/products/ProductIndex.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import ProfileView from '../components/views/UserProfileView.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import BlackoutIndex from '../components/views/blackouts/BlackoutIndex.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import ReportingShell from '../components/views/reporting/ReportingShell.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import ActivityReport from '../components/views/reporting/Activity.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import OverviewReport from '../components/views/reporting/Overview.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import BreakdownsReport from '../components/views/reporting/Breakdowns.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import CustomersReport from '../components/views/reporting/Customers.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import DailyRevenueReport from '../components/views/reporting/DailyRevenue.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import TransactionsReport from '../components/views/reporting/Transactions.vue'
import UniversalInventory from '../components/views/universal-inventory/UniversalInventory.vue'
import UniversalInventoryLog from '../components/views/universal-inventory/UniversalInventoryLog.vue'

import Sandbox from '../components/views/sandbox/Sandbox.vue'

// Locations
import LocationShell from '../components/views/locations/LocationShell.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import LocationIndex from '../components/views/locations/LocationIndex.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import LocationDetailShell from '../components/views/locations/LocationDetailShell.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import LocationDetail from '../components/views/locations/LocationDetail.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import LocationSolutions from '../components/views/locations/LocationSolutions.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import LocationProductsIndex from '../components/views/locations/location-products/LocationProductsIndex.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import LocationProductDetail from '../components/views/locations/location-products/LocationProductDetail.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import LocationVenueIndex from '../components/views/locations/LocationVenueIndex.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import LocationParcsIndex from '../components/views/locations/parcs/LocationParcsIndex.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import LocationUsers from '../components/views/locations/LocationUsers.vue'
import LocationUri from '../components/views/locations/uri/Uri.vue'


// Rate Management
import RateManagementShell from '../components/views/rate-management/RateManagementShell.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import RateManagement from '../components/views/rate-management/RateManagement.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import RateManagementLog from '../components/views/rate-management/RateManagementLog.vue'

// Users
import UserShell from '../components/views/users/UserShell.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import UserIndex from '../components/views/users/UserIndex.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import UserDetailShell from '../components/views/users/UserDetailShell.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import UserDetail from '../components/views/users/UserDetail.vue'
// @ts-ignore: suppress "Could not find a declaration file for module"
import UserSolutions from '../components/views/users/UserSolutions.vue'

// Returns a function suitable for passing to the beforeEnter key of a route
// definition.
function checkPermission(permission: string): NavigationGuard {
  return function (_to, _from) {
    if (PermissionsService.can(permission)) {
      return true
    } else {
      return {name: 'locationIndex'}
    }
  }
}

const routes: Readonly<RouteRecordRaw[]> = [
  {
    // https://router.vuejs.org/guide/essentials/dynamic-matching.html#Catch-all-404-Not-found-Route
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: NotFound,
  },
  {
    path: "/",
    name: "login",
    component: LoginView,
  },
  {
    path: "/confirm_account",
    name: "confirmAccount",
    component: ConfirmAccountView,
  },
  {
    path: "/forgot_password",
    name: "forgotPassword",
    component: ForgotPasswordView,
  },
  {
    path: "/confirm_forgot_password",
    name: "confirmForgotPassword",
    component: ConfirmForgotPasswordView,
  },
  {
    path: '/app',
    component: AuthenticatedView,
    children: [
      {
        path: '/sandbox',
        name: 'sandbox',
        component: Sandbox,
      },
      {
        path: '/locations',
        component: LocationShell,
        children: [
          {
            path: '',
            name: 'locationIndex',
            component: LocationIndex,
          },
          {
            path: ':locationID',
            component: LocationDetailShell,
            props: (route) => {
              return {
                locationID: route.params.locationID === 'new' ? 'new' : parseInt(route.params.locationID as string, 10),
              }
            },
            children: [
              {
                path: '',
                name: 'locationDetail',
                component: LocationDetail,
              },
              {
                path: 'solutions',
                name: 'locationSolutions',
                component: LocationSolutions,
              },
              {
                path: 'products',
                component: PassthroughView,
                children: [
                  {
                    path: '',
                    name: 'locationProductIndex',
                    component: LocationProductsIndex,
                  },
                  {
                    path: ':locationProductID',
                    name: 'locationProductDetail',
                    component: LocationProductDetail,
                    props: (route) => ({
                      locationProductID: route.params.locationProductID === 'new' ? null : parseInt(route.params.locationProductID as string, 10),
                    }),
                  },
                ],
              },
              {
                path: 'venues',
                component: PassthroughView,
                beforeEnter: checkPermission('vlps.read'),
                children: [
                  {
                    path: '',
                    name: 'locationVenueIndex',
                    component: LocationVenueIndex,
                  },
                ],
              },
              {
                path: 'parcs',
                name: 'locationParcs',
                component: LocationParcsIndex,
              },
              {
                path: 'users',
                name: 'locationUsers',
                component: LocationUsers,
                beforeEnter: checkPermission('users.index'),
              },
              {
                path: 'uri',
                name: 'locationUri',
                component: LocationUri,
                // permissions are checked in the Uri component
              },
            ],
          },
        ],
      },
      {
        path: '/universal-inventory/:locationID?',
        name: 'universalInventory',
        component: UniversalInventory,
        props: (route) => ({
          locationID: route.params.locationID ? parseInt(route.params.locationID as string, 10) : null,
        })
      },
      {
        path: '/universal-inventory/:locationID/log',
        name: 'universalInventoryLog',
        component: UniversalInventoryLog,
        props: (route) => ({
          locationID: parseInt(route.params.locationID as string, 10),
        })
      },
      {
        path: '/rate-management',
        component: RateManagementShell,
        children: [
          {
            path: ':locationID?',
            name: 'rateManagement',
            component: RateManagement,
            props: (route) => ({
              locationID: route.params.locationID ? parseInt(route.params.locationID as string, 10) : null,
            }),
          },
          {
            path: ':locationID/log',
            name: 'rateManagementLog',
            component: RateManagementLog,
            props: (route) => ({
              locationID: parseInt(route.params.locationID as string, 10),
            }),
          },
        ],
      },
      {
        path: '/blackouts',
        name: 'blackoutIndex',
        component: BlackoutIndex,
      },
      {
        path: '/reports',
        component: ReportingShell,
        children: [
          {
            path: 'overview',
            name: 'overviewReport',
            component: OverviewReport,
          },
          {
            path: 'breakdowns',
            name: 'breakdownsReport',
            component: BreakdownsReport,
          },
          {
            path: 'customers',
            name: 'customersReport',
            component: CustomersReport,
          },
          {
            path: 'transactions',
            name: 'transactionsReport',
            component: TransactionsReport,
          },
          {
            path: 'daily-revenue',
            name: 'dailyRevenueReport',
            component: DailyRevenueReport,
          },
          {
            path: 'activity',
            name: 'activityReport',
            component: ActivityReport,
          },
        ],
      },
      {
        path: '/organizations',
        name: 'organizationIndex',
        component: OrganizationIndex,
        beforeEnter: checkPermission('organizations.manage'),
      },
      {
        path: '/users',
        component: UserShell,
        children: [
          {
            path: '',
            name: 'userIndex',
            component: UserIndex,
            beforeEnter: checkPermission('users.index'),
          },
          {
            path: ':userID',
            component: UserDetailShell,
            props: (route) => ({
              userID: route.params.userID === 'new' ? 'new' : parseInt(route.params.userID as string, 10),
            }),
            children: [
              {
                path: '',
                name: 'userDetail',
                component: UserDetail,
                beforeEnter: checkPermission('users.index'),
              },
              {
                path: 'solutions',
                name: 'userSolutions',
                component: UserSolutions,
                beforeEnter: checkPermission('users.index'),
              },
            ],
          },
        ],
      },
      {
        path: '/products',
        name: "productIndex",
        component: ProductIndex,
        beforeEnter: checkPermission('products.write'),
      },
      {
        path: '/profile',
        name: "profile",
        component: ProfileView,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
});

router.beforeEach(async (to, _from, next) => {

  const publicPages = [
    "/",
    "/confirm_account",
    "/forgot_password",
    "/confirm_forgot_password",
  ]

  const authRequired = !publicPages.includes(to.path);

  // Determine whether the user is logged in (and their token is unexpired)

  const loggedIn = !!localStorage.getItem('user')

  // If the user is logged in, and they're trying to access an unprotected
  // route, redirect them to a default page (depending on their role)

  if (!authRequired && loggedIn) {
    if (PermissionsService.can('organizations.manage')) {
      return next({ name: 'organizationIndex' })
    } else {
      return next({ name: 'locationIndex' })
    }
  }

  // If the user is *not* logged in, and they're trying to access a protected
  // page, then redirect them to the login page

  if (authRequired && !loggedIn) {
    return next(`/?to=${encodeURIComponent(to.fullPath)}`)
  }

  // If the user is trying to view an unprotected page, or the global data
  // needed by protected pages has already been loaded, do nothing.

  if (!authRequired || GlobalDataService.isLoaded()) {
    return next()
  }

  // The user is logged in, trying to access a protected page, and global data
  // has not yet been loaded. Load it!

  await GlobalDataService.load()

  return next()

})

export default router
